<template>
  <section id="mission-vision" class="text-white py-11">
    <!-- Mission Vision -->
    <div class="flex flex-col md:flex-row justify-center items-center gap-16 p-6">
      <!-- Mission Card -->
      <div
        class="w-4/5 md:w-2/5 p-10 rounded-[86px] bg-[#111111] border border-[#0b090a] shadow-[7px_7px_14px_#0a0a0a,-7px_-7px_14px_#131313] transition-all duration-300 ease-in-out hover:scale-105 hover:brightness-110 hover:shadow-[7px_7px_14px_#e47d39,-7px_-7px_14px_#ff9f45] flex flex-col items-center text-center group"
        data-aos="fade-right"
      >
        <!-- Mission Icon -->
        <svg
          class="w-20 h-20 text-gray-500 transition-all duration-300 ease-in-out group-hover:text-[#e4ac3b] group-hover:drop-shadow-[0_0_10px_#e4ac3b]"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          role="img"
        >
          <title>Mission - Revest360 Financial Literacy</title>
          <circle cx="12" cy="12" r="9" stroke-width="2" />
          <circle cx="12" cy="12" r="5" stroke-width="2" />
          <circle cx="12" cy="12" r="2" stroke-width="2" fill="currentColor" />
        </svg>

        <h3
          class="mt-4 mb-4 text-3xl font-semibold tracking-wide text-[#e4ac3b] uppercase transition-all duration-300 group-hover:drop-shadow-[0_0_10px_#e4ac3b]"
        >
          Mission
        </h3>

        <p
          class="text-lg font-normal text-gray-400 transition-all duration-300 group-hover:text-white"
        >
          We provide an eLibrary to meet the evolving needs of the different religions. Providing
          different scriptures that are accessible wherever you go.
        </p>
      </div>

      <!-- Vision Card -->
      <div
        class="w-4/5 md:w-2/5 p-10 rounded-[86px] bg-[#111111] border border-[#0b090a] shadow-[7px_7px_14px_#0a0a0a,-7px_-7px_14px_#131313] transition-all duration-300 ease-in-out hover:scale-105 hover:brightness-110 hover:shadow-[7px_7px_14px_#e47d39,-7px_-7px_14px_#ff9f45] flex flex-col items-center text-center group"
        data-aos="fade-left"
      >
        <!-- Vision Icon -->
        <svg
          class="w-20 h-20 text-gray-500 transition-all duration-300 ease-in-out group-hover:text-[#e4ac3b] group-hover:drop-shadow-[0_0_10px_#e4ac3b]"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          role="img"
        >
          <title>Vision - Digital Religious Library</title>
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 4.5c-4.33 0-8.25 2.91-9.83 7.05a1.003 1.003 0 000 .9C3.75 16.59 7.67 19.5 12 19.5s8.25-2.91 9.83-7.05a1.003 1.003 0 000-.9C20.25 7.41 16.33 4.5 12 4.5zM12 15a3 3 0 110-6 3 3 0 010 6z"
          />
        </svg>

        <h3
          class="mt-4 mb-4 text-3xl font-semibold tracking-wide text-[#e4ac3b] uppercase transition-all duration-300 group-hover:drop-shadow-[0_0_10px_#e4ac3b]"
        >
          Vision
        </h3>

        <p
          class="text-lg font-normal text-gray-400 transition-all duration-300 group-hover:text-white"
        >
          To be the world’s leading digital library for religious scriptures, fostering universal
          access and understanding across diverse faith communities
        </p>
      </div>
    </div>
  </section>
</template>


<script setup>
import { useAos } from '../hooks/useAos';

useAos({ easing: 'ease-in-out' });
</script>